module.exports['_locutus_shared_bc'] = require('./_locutus_shared_bc')
